import { HTMLProps } from "react";
import { twMerge } from "tailwind-merge";
import { AlertType } from "./AlertType";

export const AlertContainer = ({
  type = "default",
  ...props
}: {
  type?: AlertType;
} & HTMLProps<HTMLDivElement>) => (
  <div
    {...props}
    className={twMerge(
      type === "default" && "border-gray-300 bg-gray-100",
      type === "information" && "border-blue-300 bg-blue-100",
      type === "success" && "border-emerald-300 bg-emerald-100",
      type === "warning" && "border-orange-300 bg-orange-100",
      type === "error" && "border-red-200 bg-red-100 text-red-800",
      type === "discount" && "border-purple-200 bg-purple-100 text-purple-800",
      "pointer-events-auto block w-fit rounded-lg border p-3 text-sm",
      props.className,
    )}
  />
);
